import { ArrowLeft, Home, Wrench } from "lucide-react";
import React from "react";
import AppLogo from "../ui/AppLogo";

interface PageUnderConstructionProps {
  onGoBack?: () => void;
  onGoHome?: () => void;
}

const PageUnderConstruction: React.FC<PageUnderConstructionProps> = ({
  onGoBack,
  onGoHome,
}) => {
  const handleGoBack = () => {
    if (onGoBack) {
      onGoBack();
    } else {
      window.history.back();
    }
  };

  const handleGoHome = () => {
    if (onGoHome) {
      onGoHome();
    } else {
      window.location.href = "/admin";
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {/* Animated Logo Container */}
        <div className="relative mb-8">
          <div className="w-full h-full flex items-center justify-center">
            {/* Company Logo Placeholder - Replace with your actual logo */}
            <AppLogo />
          </div>

          {/* Floating Animation Elements */}
          <div className="absolute -top-2 -right-2 w-6 h-6 bg-yellow-400 rounded-full animate-bounce delay-500"></div>
          <div className="absolute -bottom-2 -left-2 w-4 h-4 bg-green-400 rounded-full animate-bounce delay-1000"></div>
        </div>

        {/* Main Construction Icon */}
        <div className="mb-6">
          <div className="w-20 h-20 mx-auto bg-orange-100 rounded-full flex items-center justify-center mb-4 animate-bounce">
            <Wrench className="w-10 h-10 text-orange-500 transform rotate-12" />
          </div>
        </div>

        {/* Content */}
        <div className="space-y-4 mb-8">
          <h1 className="text-3xl font-bold text-gray-800 opacity-0 animate-fade-in-up">
            Page Under Construction
          </h1>
          <p className="text-gray-600 leading-relaxed opacity-0 animate-fade-in-up animation-delay-200">
            We're working hard to bring you this feature. This page will be
            available soon with exciting new functionality.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center opacity-0 animate-fade-in-up animation-delay-400">
          <button
            onClick={handleGoBack}
            className="flex items-center justify-center gap-2 px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-md"
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </button>

          <button
            onClick={handleGoHome}
            className="flex items-center justify-center gap-2 px-6 py-3 bg-primary hover:bg-primary/90 text-white rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-lg"
          >
            <Home className="w-4 h-4" />
            Dashboard
          </button>
        </div>

        {/* Progress Indicator */}
        <div className="mt-8 opacity-0 animate-fade-in-up animation-delay-600">
          <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
            <div className="bg-gradient-to-r from-primary/10 to-primary/95 h-2 rounded-full animate-progress"></div>
          </div>
          <p className="text-xs text-gray-500 mt-2">Coming Soon...</p>
        </div>

        {/* Floating particles for extra animation */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-blue-300 rounded-full animate-float opacity-50"></div>
          <div className="absolute top-3/4 right-1/4 w-3 h-3 bg-purple-300 rounded-full animate-float-delayed opacity-40"></div>
          <div className="absolute top-1/2 left-3/4 w-2 h-2 bg-pink-300 rounded-full animate-float-slow opacity-30"></div>
        </div>
      </div>
    </div>
  );
};

export default PageUnderConstruction;
